import {BaseSlider} from "../BaseSlider";
import ICustomForm from "../../ICustomForm";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";

export default class SliderNumericLabeled extends BaseSlider implements ICustomForm
{
    constructor(settings: ICustomFormSettings) {
        super(settings);
        for (const box of this.sliderBoxes) {
            box.type = "numeric-labeled";
        }
    }

    public view(): Vnode {
        return this.viewLayout(
            m("form", {}, [
                m(this.sliderBoxes[0]),
                ...this.checkboxCells.map(i => m(i))
            ])
        );
    }
}
